var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStockistsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.849 7.68L13.849 0.637001C12.761 -0.214999 11.24 -0.214999 10.152 0.637001L1.151 7.68C0.42 8.252 0 9.114 0 10.043V24H6V13C6 12.449 6.448 12 7 12H17C17.552 12 18 12.449 18 13V24H24V10.043C24 9.114 23.58 8.252 22.849 7.68ZM22 22H20V13C20 11.346 18.654 10 17 10H7C5.346 10 4 11.346 4 13V22H2V10.043C2 9.733 2.14 9.446 2.384 9.255L11.384 2.212C11.747 1.928 12.253 1.928 12.616 2.212L21.616 9.255C21.86 9.446 22 9.733 22 10.043V22ZM8 20H11V24H8V20ZM8 14H11V18H8V14ZM13 20H16V24H13V20Z",
    fill: "#0084D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockistsIcon);
export default __webpack_public_path__ + "static/media/stockists-icon.8232a23f19ab9c935e953ac29e4bcf0b.svg";
export { ForwardRef as ReactComponent };